// extracted by mini-css-extract-plugin
export default {"row":"style_row__uD4K6","bg":"style_bg__elzoq"};